import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import { ErrorModal } from '../../../components/modals/error-modal';
import { messages } from './messages';

import style from './style.module.less';

export const ReturnsUnsavedChangesModal = ({ modalFrameworkMethods, onContinue }) => {
  const onContinueButtonClick = () => {
    modalFrameworkMethods.closeModal();
    onContinue();
  };

  return (
    <ErrorModal
      buttons={[
        {
          onClick: modalFrameworkMethods.cancelModal,
          theme: 'tertiary',
          children: <FormattedMessage {...messages.cancelButton} />,
        },
        {
          onClick: onContinueButtonClick,
          theme: 'primary',
          children: <FormattedMessage {...messages.continueButton} />,
        },
      ]}
      className={style.modal}
      message={
        <div className={style.content}>
          <FormattedMessage {...messages.modalContent} />
        </div>
      }
      modalFrameworkMethods={modalFrameworkMethods}
      state='warning'
      title={<FormattedMessage {...messages.title} />}
    />
  );
};

ReturnsUnsavedChangesModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  onContinue: PropTypes.func.isRequired,
};
